export default __webpack_public_path__ + "london-cfe6d983949990821225c0ea788cf575.bundle.jpg";